import { render, staticRenderFns } from "./CompanyCouncil.vue?vue&type=template&id=22063d90&"
import script from "./CompanyCouncil.vue?vue&type=script&lang=ts&"
export * from "./CompanyCouncil.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports